import React, { useState } from 'react';
import { Lock, X } from 'lucide-react';
import { useTranslation } from '../../i18n.ts';

const ViewerBanner: React.FC<{ isViewer: boolean }> = ({ isViewer }) => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);
  if (!isViewer || dismissed) return null;
  return (
    <div className="flex items-center gap-3 px-4 py-2.5 bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800/30 text-sm text-amber-800 dark:text-amber-200 shrink-0">
      <Lock size={14} className="shrink-0" />
      <span className="flex-1">{t('viewerBanner')}</span>
      <button
        onClick={() => setDismissed(true)}
        className="shrink-0 p-1 hover:bg-amber-200/50 dark:hover:bg-amber-800/30 rounded"
        aria-label={t('close')}
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default ViewerBanner;
